module.exports = __webpack_public_path__ + "static/media/wi.931e03a0.svg";